import React from 'react';
import { motion } from 'framer-motion';
import SubscriptionGate from '../components/SubscriptionGate';

function Predictions() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#151C2A] via-[#0C1017] to-[#080B10]" />
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 0.45, scale: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="absolute left-12 top-12 h-56 w-56 rounded-full bg-primary/30 blur-3xl"
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 0.35, scale: 1 }}
          transition={{ duration: 1, ease: 'easeOut', delay: 0.2 }}
          className="absolute bottom-10 right-16 h-64 w-64 rounded-full bg-sky-500/30 blur-3xl"
        />
      </div>
      <div className="relative mx-auto flex max-w-5xl flex-col gap-10 px-6 py-16 text-white">
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">Insights</p>
          <h1 className="text-4xl font-semibold">Predictions</h1>
          <p className="text-sm text-white/60">
            Dive into AI-driven forecasts for your connected assets. Upgrade your subscription to unlock predictive
            analytics tailored to your devices.
          </p>
        </div>
        <SubscriptionGate />
      </div>
    </div>
  );
}

export default Predictions;
